import { ConvenienceFee, DomesticTax } from '@features/admin/feeSettings';

export const FeeSettingsPage = () => {
  return (
    <div className={'flex flex-col gap-15'}>
      <ConvenienceFee />
      <DomesticTax />
      {/*<InternationalTax />*/}
    </div>
  );
};
